export const RISK_CATEGORY_TAGS = [
  {
    label: "Global Issues",
    id: "a0575d68-4585-4a8f-a016-3dff84e46434",
    isCyber: false,
    isGlobal: true,
  },
  {
    label: "Monthly Outlook",
    id: "2f5b0ec1-376a-4955-8b85-99a84d2de0f7",
    isCyber: false,
    isGlobal: false,
  },
  {
    label: "Big Picture Series",
    id: "14536d98-6f81-4c1a-9d54-f20008a20e03",
    isCyber: false,
    isGlobal: false,
  },
  {
    label: "Cyber - Daily",
    id: "330cb564-8398-4364-99df-260ff63f248e",
    isCyber: true,
    isGlobal: true,
  },
  {
    label: "Cyber - Weekly",
    id: "9b08f9fa-f14d-4034-aabb-3f9d92822d7c",
    isCyber: true,
    isGlobal: true,
  },
  {
    label: "Cyber - Monthly",
    id: "43c13d53-cbf9-4e20-b251-4039442d7642",
    isCyber: true,
    isGlobal: true,
  },
];
